/* globalmodule */
define('../src/sublayouts/m80-my-consumption/m80-my-consumption',['jquery'], function($) {

    'use strict';

    var M80 = function($component) {

        this.$component = $component;
        return this;
    };

    M80.prototype.init = function() {
        var _this = this,
            $rate = this.$component.find('.circle-foreground'),
            $num = parseFloat(this.$component.attr('data-rate')),
            $ratenum = ($num/100)*300;

        $rate.css('stroke-dasharray', $ratenum.toString()+' 624.86px')
    };

    return M80;

});

